import { useI18n } from '../i18n';
import type { ConnectionPhase } from '../match/machine';

/**
 * 重連橫幅。
 *
 * C02 §6.3 明文：**斷線不等於棄權**。所以這裡除了「重新連線中」之外，一定要把
 * 「這不算你輸」講清楚 —— 玩家最怕的就是網路一抖就被判輸。
 * 這也是為什麼 banner 是 sticky 而不是蓋住畫面的 modal：對局狀態必須全程看得見。
 */
export function ReconnectBanner({ connection, attempt }: { connection: ConnectionPhase; attempt: number }) {
  const { t } = useI18n();
  if (connection === 'online') return null;

  const offline = connection === 'offline';
  return (
    <div className="reconnect-banner" role="status" aria-live="polite">
      <strong>
        <span className="reconnect-banner__dot" aria-hidden="true" />
        {offline ? t('conn.offline') : t('conn.reconnecting', { attempt: Math.max(1, attempt) })}
      </strong>
      <span>{t('conn.reconnecting.safe')}</span>
    </div>
  );
}
